<template>
  <div v-loading.lock="loading">
    <div class="mainLogoPosition text-center">
      <!-- <img src="@/assets/echob2b_logo.svg" class="mb-5 " style="width: 200px"> -->
      <img src="@/assets/gregorys_logo.png" class="mb-5" style="width: 200px" />
    </div>
    <el-row>
      <el-col>
        <el-form
          v-if="loginCard"
          :model="LoginForm"
          status-icon
          :rules="rules"
          ref="LoginForm"
          label-width="120px"
          class="LForm"
        >
          <el-form-item prop="username">
            <el-input
              v-model="LoginForm.username"
              :placeholder="this.$translation('b2b_mobile')"
            >
              <i slot="prepend" class="el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input
              type="password"
              v-model="LoginForm.pass"
              @keyup.enter.native="submitForm('LoginForm')"
              auto-complete="off"
              :placeholder="this.$translation('b2b_password')"
            >
              <i slot="prepend" class="el-icon-lock"></i>
            </el-input>
          </el-form-item>
          <div class="error-message-container" v-html="this.errorMessage"></div>
          <div v-if="!account">
            <el-form-item>
              <el-row :gutter="5">
                <el-col :span="12" :xs="24">
                  <el-button
                    class="mt-3"
                    type="primary"
                    @click="submitForm('LoginForm')"
                    >{{ this.$translation('b2b_login') }}</el-button
                  >
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-button
                    class="mt-3"
                    type="primary"
                    @click="$router.push('/register')"
                    >{{ this.$translation('b2b_create_account') }}</el-button
                  >
                </el-col>
              </el-row>
              <p
                class="text-center pointer resetText"
                @click="$router.push('/resetpassword')"
              >
                {{ this.$translation('b2b_forgot_password') }}
              </p>
            </el-form-item>
            <p class="text-center">{{ this.$translation('b2b_or') }}</p>
            <el-form-item>
              <el-button type="primary" @click="login"
                >Microsoft {{ this.$translation('b2b_login') }}</el-button
              >
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item>
              <el-button type="primary" @click="logout"
                >Microsoft {{ this.$translation('b2b_login') }}</el-button
              >
            </el-form-item>
          </div>
        </el-form>
        <el-form
          v-else
          :model="ResetForm"
          status-icon
          :rules="ResetRules"
          ref="ResetForm"
          label-width="120px"
          class="LForm"
        >
          <el-form-item prop="Email">
            <el-input
              v-model="ResetForm.Email"
              @keyup.enter.native="submitResetForm('ResetForm')"
              auto-complete="off"
              placeholder="Email"
            >
              <span slot="prepend">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="12"
                  viewBox="0 0 19 12"
                >
                  <path
                    fill="#5C5C5C"
                    fill-rule="nonzero"
                    d="M1.282 2.848v7.448c0 .342.278.62.62.62h15.12a.62.62 0 0 0 .62-.62V2.783l-7.246 4.419c-.607.37-1.368.37-1.975 0L1.28 2.848zm0-.929l7.552 4.606c.353.215.796.215 1.15 0l7.657-4.67a.621.621 0 0 0-.62-.607H1.902a.621.621 0 0 0-.62.622v.05zm15.74 9.79H1.901c-.78 0-1.413-.633-1.413-1.413V1.87c0-.781.633-1.415 1.413-1.415h15.12c.78 0 1.413.634 1.413 1.415v8.426c0 .78-.633 1.413-1.414 1.413z"
                  />
                </svg>
              </span>
            </el-input>
          </el-form-item>
          <p class="text-center">
            Enter your email and we will send you an email to change the
            password!
          </p>
          <el-form-item>
            <el-button type="primary" @click="submitResetForm('ResetForm')"
              >Submit</el-button
            >
          </el-form-item>
          <p class="text-center pointer resetText" @click="$router.push('/')">
            Back to login
          </p>
        </el-form>
        <!-- <form class="login" @submit.prevent="login">
              <h1>Sign in</h1>
              <label>User name</label>
              <input required v-model="username" type="text" placeholder="Snoopy"/>
              <label>Password</label>
              <input required v-model="password" type="password" placeholder="Password"/>
              <hr/>
              <button type="submit">Login</button>
          </form>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { auth, getToken } from '@/SSO/config/auth.js';
import { AUTH_REQUEST } from '@/store/actions/auth';
import { isValidEmail } from '@/utils/validate';
import { ResetPassApi } from '@/utils/echoApi';
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('Please input the password'))
    //   } else {
    //     if (this.ruleForm.checkPass !== '') {
    //       // this.$refs.ruleForm.validateField('checkPass')
    //       alert('έλεγχος regex κωδικού')
    //     }
    //     callback()
    //   }
    // }
    const validateEmail = (rule, value, callback) => {
      if (!isValidEmail(value)) {
        callback(new Error('Please enter a valid email'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('The password cannot be empty'));
      } else if (value.length < 2) {
        callback(new Error('The password can not be less than 6 digits'));
      } else {
        callback();
      }
    };
    return {
      // username: 'dogo',
      // password: 'dogy',
      account: false,
      loading: false,
      loginCard: true,
      errorMessage: '',
      LoginForm: {
        username: '',
        pass: ''
      },
      rules: {
        username: [{ required: true, trigger: 'blur' }],
        pass: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      ResetRules: {
        Email: [{ required: true, trigger: 'blur', validator: validateEmail }]
      },
      ResetForm: {
        Email: ''
      }
    };
  },
  computed: {
    ...mapState('data', {
      hostname: state => state.hostname
    })
  },
  async mounted() {
    this.account = auth.getAccount();
    if (this.account) {
      this.errorMessage = '';
      this.loading = true;
      const token = await getToken();
      this.$store
        .dispatch(AUTH_REQUEST, { token })
        .then(() => {
          this.SET_MICROSOFT_LOGIN(true);
          this.$router.push('/dashboard');
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status === 422) {
            this.open();
          }
          if (error.response.status === 404) {
            this.notFound();
          }
        });
    }
  },
  methods: {
    ...mapMutations('data', ['SET_MICROSOFT_LOGIN']),
    logout() {
      auth.logout();
    },
    login() {
      this.loading = true;
      auth.loginRedirect();
    },
    submitForm(formName) {
      this.errorMessage = '';
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          const { username, pass } = this.LoginForm;
          this.$store
            .dispatch(AUTH_REQUEST, { username, pass })
            .then(() => {
              this.$router.push('/dashboard');
            })
            .catch(error => {
              this.loading = false;
              if (error.response.status === 422) {
                this.open();
              }
            });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    submitResetForm(formName) {
      var self = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http
            .post('https://' + this.hostname + ResetPassApi, {
              email: this.ResetForm.Email
            })
            .then(response => {
              if (response.status === 200) {
                // this.AddTaskForm.assignee = this.AddTaskForm.assigned_id[0]
                // this.$store.commit('data/addNewTask', this.AddTaskForm)
                this.$message({
                  message: 'reset password done',
                  type: 'success'
                });
                setTimeout(function() {
                  self.loginCard = !this.loginCard;
                }, 2000);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      });
    },
    open() {
      this.errorMessage = this.$translation('b2b_wrong_username_password');
      // this.$notify.error({
      //   title: 'Error',
      //   message: 'Wrong Credentials'
      // });
    },
    notFound() {
      this.errorMessage = this.$translation('b2b_user_not_found');
      // this.$notify.error({
      //   title: 'Error',
      //   message: 'User does not exist'
      // });
    }
  }
};
</script>
<style lang="scss">
.LForm {
  .el-input-group__prepend {
    background-color: #edf0f0;
    border: none;
    padding-right: 0px;
  }
  .el-form-item__content {
    margin-left: 0px !important;
  }
  .el-input__inner {
    font-weight: 600;
  }
  .el-input__suffix {
    color: #509fec;
  }
  .el-button--primary {
    border-radius: 2px;
    background-color: #03a7fa;
    width: 100%;
  }
  .card {
    width: 464px;
    height: 329.8px;
  }
}
.mainLogoPosition {
  width: 100%;

  img {
    max-width: 200px;
  }
}
.resetText {
  color: var(--main-color);
  font-size: 12px;
}
.error-message-container{
  width: 100%;
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginForm/index.vue